"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizedStringsJSONObject = void 0;
/**
 * A type providing access to underlying localized strings JSON object.
 */
class LocalizedStringsJSONObject {
    /**
     * Create localized strings JSON object.
     *
     * @param strings - A dictionary containing localized strings.
     */
    constructor(strings) {
        this.strings = strings;
    }
    // MARK: - Localized Strings
    string(key) {
        return this.strings[key];
    }
}
exports.LocalizedStringsJSONObject = LocalizedStringsJSONObject;
